import { createContext, useState } from "react";
import { post } from "../../core/client";
import LegalTextV2Modal from "./LegalTextV2Modal";

interface LegalTexts {
    contracts: LegalContractItem[];
    consents: LegalContractConsentItem[];
}

interface LegalContractItem {
    type: string;
    text: string;
}

interface LegalContractConsentItem {
    type: string;
    text: string;
    contractType: string;
    required: boolean;
}

export enum LegalContractType {
    AYDINLATMA_METNI = 'AYDINLATMA_METNI',
    UYELIK_SOZLESMESI = 'UYELIK_SOZLESMESI',
    YKB_AKTARIM_SOZLESMESI= 'YKB_AKTARIM_SOZLESMESI'
}

export enum LegalContractConsentType {
    VERI_IZNI = 'VERI_IZNI',
    YKB_VERI_AKTARIM_IZNI = 'YKB_VERI_AKTARIM_IZNI',
    YURT_DISI_VERI_IZNI = 'YURT_DISI_VERI_IZNI',
    VAKIF_DERNEK_IZNI = 'VAKIF_DERNEK_IZNI',
    UYELIK_SOZLESMESI = 'UYELIK_SOZLESMESI',
    ETK_IZNI = 'ETK_IZNI',
    YKB_AYDINLATMA = 'YKB_AYDINLATMA',
    COCUK_ETK_IZNI='COCUK_ETK_IZNI'
}

interface JoinFormUndeageContextModel {
    showLegalTextModal: boolean;
    legalTextLoading: boolean;
    legalTexts: LegalTexts | null;
    selectedConsentType: string;
    loadLegalTexts: (types: LegalContractConsentType[]) => void;
    openLegalTextModal: (type: LegalContractConsentType) => void;
    closeLegalTextModal: () => void;
}

const defaultModel: JoinFormUndeageContextModel = {
    showLegalTextModal: false,
    legalTextLoading: false,
    legalTexts: null,
    selectedConsentType: "",
    loadLegalTexts: (types: LegalContractConsentType[]) => { },
    openLegalTextModal: (type: LegalContractConsentType) => { },
    closeLegalTextModal: () => { },
}

export const JoinFormUndeageContext = createContext<JoinFormUndeageContextModel>(defaultModel);

const JoinFormUndeageContextProvider = (props: any) => {

    const [legalTextLoading, setLegalTextLoading] = useState(false);
    const [showLegalTextModal, setShowLegalTextModal] = useState(false);
    const [legalTexts, setLegalTexts] = useState<LegalTexts | null>(defaultModel.legalTexts);
    const [selectedConsentType, setSelectedConsentType] = useState<string>(defaultModel.selectedConsentType);

    const loadLegalTexts = async (types: LegalContractConsentType[]) => {
        if(legalTexts != null) return;

        setLegalTextLoading(true);
        const request = {consentType: types.map(x => LegalContractConsentType[x])};
        var { data, fail, errorMessage } = await post<LegalTexts>(`api/membership/get-form-legal-consentsUa`, request);
        setLegalTextLoading(false);
        if (!fail && data) {
           
            setLegalTexts(data)
        }
    };

    const openLegalTextModal = (type: LegalContractConsentType) => {
       
        setSelectedConsentType(LegalContractConsentType[type]);
        setShowLegalTextModal(true);
    }

    const closeLegalTextModal = () => {
        setSelectedConsentType("");
        setShowLegalTextModal(false);
    }

    return (
        <JoinFormUndeageContext.Provider value={{
            showLegalTextModal, legalTextLoading, legalTexts, selectedConsentType,
            loadLegalTexts, openLegalTextModal, closeLegalTextModal
        }}>
            {props.children}
            <LegalTextV2Modal
                onClose={closeLegalTextModal} context={JoinFormUndeageContext} />
        </JoinFormUndeageContext.Provider>
    );
}

export default JoinFormUndeageContextProvider;
